import { render, staticRenderFns } from "./AffinityDisplay.vue?vue&type=template&id=243158c7&"
import script from "./AffinityDisplay.vue?vue&type=script&lang=ts&"
export * from "./AffinityDisplay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports